import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-toggle-button',
  templateUrl: './toggle-button.component.html',
  styleUrls: ['./toggle-button.component.scss']
})
export class ToggleButtonComponent {

  @Input() cashNowStatusUser: boolean = false;
  @Output() cashNowStatusChange = new EventEmitter<boolean>();

  constructor() { }

  onCheckboxChange(isChecked: boolean){
    this.cashNowStatusChange. emit(isChecked);
  }

}